<template>
    <v-form
        ref="refFormForgetPassword"
        v-model="formForgetPassword.valid"
        lazy-validation
        @submit.prevent="forgetPassword"
        transition="slide-x-reverse-transition"
    >
        <v-card
            :loading="loading"
            outlined
            class="v-card--custom"
        >
            <v-card-text>
                <v-text-field
                    type="email"
                    name="email"
                    label="Email"
                    append-icon="email"
                    v-model="formForgetPassword.model.email"
                    :rules="formForgetPassword.rules.email"
                    required
                ></v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    text
                    @click="changeForm(true)"
                    small
                >Voltar</v-btn>

                <v-spacer></v-spacer>

                <v-btn
                    type="submit"
                    color="primary"
                    :disabled="!formForgetPassword.valid"
                    :loading="loading"
                    large
                    @click.prevent="forgetPassword()"
                >Enviar</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
export default {
    name: 'form-forget-password',
    props: ['loading'],
    data: () => ({
        formForgetPassword: {
            valid: true,
            model: {
                email: ''
            },
            rules: {
                email: [
                    v => !!v || 'E-mail é obrigatório',
                    v => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(v) || 'Utilize um e-mail válido'
                    }
                ]
            }
        }
    }),
    methods: {
        changeForm (boolean) {
            this.$emit('change-form', boolean)
        },
        forgetPassword () {
            if (this.$refs.refFormForgetPassword.validate()) {
                this.$emit('forget-password', this.formForgetPassword.model)
            }
        }
    }
}
</script>
